import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { useFormikContext, useField } from 'formik'

// Components
import Datepicker from '@/components/common/Datepicker'

// Variables / Functions
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const currentYear = new Date().getFullYear()
const currentMonth = new Date().getMonth() + 1
const currentDate = new Date().getDate()

export const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  defaultPickerValue: PropTypes.string,
}

export const defaultProps = {
  onChange: () => {},
  defaultPickerValue: `${currentYear}/${currentMonth}/${currentDate}`,
}

function DatepickerField(props) {
  const { className, name, onChange: onChangeProps, defaultPickerValue, ...restProps } = props
  const [field] = useField(props)
  const { setFieldValue } = useFormikContext()

  const onChange = (date, dateString) => {
    setFieldValue(name, dateString)

    onChangeProps(dateString)
  }

  return (
    <div className={cx('date-picker-field-wrapper', className)}>
      <Datepicker
        className={cx('date-picker-field-wrapper-item', className)}
        onChange={onChange}
        defaultValue={field?.value ? field?.value : ''}
        defaultPickerValue={field?.value ? field?.value : defaultPickerValue}
        value={field?.value ? field?.value : ''}
        {...restProps}
      />
    </div>
  )
}

DatepickerField.propTypes = propTypes
DatepickerField.defaultProps = defaultProps

export default DatepickerField
